module.exports = __webpack_public_path__ + "img/kontakt_640.ba83833a.webp";